// URL of the iris extraction app (eye-isolate). Update here when its custom domain works.
export const APP_URL = "https://eye-isolate.preview.emergentagent.com";
export const APP_LOGIN_URL = APP_URL;
export const APP_REGISTER_URL = APP_URL;
